import * as React from "react";

function SvgRecMobileHeaderContact(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
      <circle cx={11} cy={11} r={11} fill="#fff" />
      <g fill="#f2a7b3">
        <path d="M17.231 11.954l-1.608-1.671 1.608-1.386v3.057zM6.379 10.283l-1.61 1.673V8.897l1.61 1.386zM17.231 13.473v1.538a.674.674 0 01-.674.674H5.443a.674.674 0 01-.674-.674v-1.538l2.408-2.5 2.752 2.37a1.696 1.696 0 002.144 0l2.75-2.37z" />
        <path d="M17.231 6.987v.673l-5.877 5.063a.573.573 0 01-.708 0L4.769 7.66v-.673a.672.672 0 01.674-.672h11.114a.672.672 0 01.674.672z" />
      </g>
    </svg>
  );
}

export default SvgRecMobileHeaderContact;
